<template>
  <div>
    <div v-if="loader">
      <Loader />
    </div>
    
  <!-- <div v-if="showNoDataImgForUser">
    <div class="progressImgDataContainer">
      <div class="progressDataText">
        <h4>Your data has been successfully added to Weavr!</h4>
        <p>Please check back in 24 hours.</p>
      </div>
      <div class="progressImgWrapper">
        <img
          src="Icons_SVG/progressDataImgUpdated.svg"
          alt="data in progress"
        />
      </div>
    </div>
  </div> -->
  <div v-else id="PriceFunFood">
    <div
      data-html2canvas-ignore="true"
      class="customdim"
      v-if="
        loader ||
        loader0 ||
        loader1 ||
        loaderPinList ||
        tableloader ||
        trendLinePincodeLoader ||
        firstTimeTrendLineLoader ||
        downloadExelLoader ||
        loaderStatus
      "
    >
      <Loader />
    </div>
    <div class="datepickerwrap card">
      <div class="d-flex justify-content-between align-items-center flex-wrap" >
        <div class="d-flex flex-wrap customWidth-70"  id="disparity-filters">
          <div style="min-width: 100px" class="mr-2">
            <div
              class="mb-1 ml-1"
              style="font-size: 14px; font-weight: 400; color: #1e1e1e"
            >
              {{ translatedLang["Date"][selectedLanguage.key] }}
            </div>
            <date-range-picker
              v-model="dateSingle"
              :show-dropdowns="true"
              opens="right"
              :autoApply="true"
              :locale-data="{ format: 'dd mmm yyyy' }"
              :single-date-picker="true"
              :min-date="minDate"
              :max-date="maxDate"
              :ranges="false"
            >
            </date-range-picker>
            <!-- :max-date="maxDate" :min-date="minDate" -->
          </div>
          <div
            class="customMultiselectCommon mx-0"
            style="min-width:100px; max-width: 200px"
          >
            <div
              class="mb-1 ml-1"
              style="font-size: 14px; font-weight: 400; color: #1e1e1e"
            >
              {{ translatedLang["Platform"][selectedLanguage.key] }}
            </div>
            <!-- :custom-label="updateSelectedLabels" -->
           
            <multiselect
              @input="handlePlatformSelection"
              v-model="selectedPlatform"
              class="text-capitalize"
              :options="platformList"
              track-by="key"
              label="value"
              :custom-label="updateSelectedLabels"
              :multiple="true"
              :searchable="false"
              placeholder="Select Platform"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedPlatform?.length == platformList?.length ? 1 : 100
              "
            >
              <template #option="{ option }">
                <div class="tw-flex tw-gap-2">
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedPlatform"
                  />
                  <div class="custom-option text-capitalize">
                    {{ option.value }}
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2 ml-2"
            style="min-width:100px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Category"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedTableCategory"
              class="text-capitalize"
              :options="categoryList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Category"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedTableCategory?.length == categoryList?.length ? 1 : 100
              "
              @input="handleChangeCategory"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedTableCategory"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width:100px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Sub Category"][selectedLanguage.key] }}
            </div> 
            <multiselect
              v-model="selectedTableSubCategory"
              class="text-capitalize"
              :options="subCategoryList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Sub Category"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedTableSubCategory?.length == subCategoryList?.length
                  ? 1
                  : 100
              "
              @input="handleChangeSubCategory"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedTableSubCategory"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
            </multiselect>
          </div>

          <div
            class="customMultiselectCommon mr-2"
            style="min-width:100px; max-width: 200px"
            v-if="labelList && labelList.length"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              Label
            </div> 
            <multiselect
              v-model="selectedLabel"
              class="text-capitalize"
              :options="labelList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Lebel"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedLabel?.length == labelList?.length
                  ? 1
                  : 100
              "
              @input="handleLabel"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedLabel"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
            </multiselect>
          </div>

          <div
            class="customMultiselectCommon mr-2"
            style="min-width:100px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Brand"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="lossSelectedBrand"
              class="text-capitalize"
              :options="lossBrandList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Brand"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                lossSelectedBrand?.length == lossBrandList?.length ? 1 : 100
              "
              @input="handleBrand"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="lossSelectedBrand"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
              <!-- <template #singleLabel="{ option }">
              {{ option.displayname.replaceAll("_", " ") }}
            </template> -->
            </multiselect>
          </div> 
             <div
            class="customMultiselectCommon mr-2"
             style="min-width:100px; max-width: 220px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Price Range"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="lossSelectedPriceRange"
              class="text-capitalize"
              :options="lossPriceRangeList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Price Range"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                lossSelectedPriceRange?.length == lossPriceRangeList?.length
                  ? 1
                  : 100
              "
              @input="handlePriceRange"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="lossSelectedPriceRange"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
              <template #singleLabel="{ option }">
                {{ option.displayname.replaceAll("_", " ") }}
              </template>
            </multiselect>
          </div>

          <div
            class="customMultiselectCommon mr-2"
            style=" max-width: 180px"
          >
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Product"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="lossSelectedProduct"
              limit="1"
              :options="lossProductList"
              :multiple="true"
              :searchable="true"
              placeholder="Select Product"
              :close-on-select="false"
              :allow-empty="true"
              :showLabels="false"
              track-by="key"
              label="value"
              :limit="lossSelectedProduct?.length == lossProductList?.length? 1: 1000"
              @input="handleProductIdSelection"
            >
              <template #option="{ option }">
                <div>
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="lossSelectedProduct"
                  />
                  <span class="option__title ml-3">{{ option.value }}</span>
                </div>
              </template>
            </multiselect>
          </div>
          <div v-if="lossSelectedPIN"
            class="custom_pincode_dropdown customMultiselect mr-3"
            style="max-width: 200px"
          >
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Pincode"][selectedLanguage.key] }}
            </div>
            <treeselect
              v-model="lossSelectedPIN"
              :options="lossPINList"
              track-by="id"
              label="label"
              :limit="1"
              value-consists-of="LEAF_PRIORITY"
              :disable-branch-nodes="false"
              placeholder="Select PIN(s)"
              :multiple="true"
              :searchable="true"
              @select="handleSelectPinChange"
            >
              <span slot="noResult">{{
                translatedLang["No elements found"][selectedLanguage.key]
              }}</span>
            </treeselect>
          </div>
            <div
            class="customMultiselectCommon mr-2"
            style="max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Batch - Time"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="lossSelectedBatch"
              class="text-capitalize"
              :options="lossBatchList"
              track-by="batch"
              label="displayname"
              :multiple="false"
              :searchable="false"
              placeholder="Select Batch"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="true"
            >
              <template #option="{ option }">
                <span class="option__title ml-3 text-capitalize">{{
                  option.displayname.replaceAll("_", " ")
                }}</span>
              </template>
              <template #singleLabel="{ option }">
                {{ option.displayname.replaceAll("_", " ") }}
              </template>
            </multiselect>
          </div>
          <div class="d-flex align-items-end mb-1">
            <button @click="filterApply" class="btn primarycolor ml-3">
              {{ translatedLang["Apply Filters"][selectedLanguage.key] }}
            </button>
          </div>
          <!-- <div class="d-lg-none d-flex align-items-center mt-3">
            <div
              class="d-flex justify-content align-items-center ml-2 competitorCheckBox"
            >
              <div class="form-check form-check-inline">
                <input
                  @change="toggleCompetitorCheckBoxDataValue"
                  class="form-check-input"
                  type="checkbox"
                  id="inlineCheckbox1"
                  :value="competitorCheckBoxDataValue"
                />
                <span class="form-check-label" for="inlineCheckbox1">
                  {{ translatedLang["Competitor Data"][selectedLanguage.key] }}
                </span>
              </div>
            </div>
            <router-link to="/price-tracking-compare">
              <button class="btn compareBtn">
                {{ translatedLang["Compare"][selectedLanguage.key] }}
              </button>
            </router-link>
          </div> -->
        </div>
        <div class="d-none d-lg-flex justify-content-end align-items-center">
          <!-- <button class="btn insights">
                        insights
                    </button> -->
          <!-- <div
            class="d-flex justify-content align-items-center ml-2 competitorCheckBox"
          >
            <div class="form-check form-check-inline">
              <input
                @change="toggleCompetitorCheckBoxDataValue"
                class="form-check-input"
                type="checkbox"
                id="inlineCheckbox1"
                :value="competitorCheckBoxDataValue"
              />
              <span class="form-check-label" for="inlineCheckbox1">
                {{
                  translatedLang["Competitor Data"][selectedLanguage.key]
                }}</span
              >
            </div>
          </div> -->
          <router-link to="/price-tracking-compare">
            <button class="btn compareBtn">
              {{ translatedLang["Compare"][selectedLanguage.key] }}
            </button>
          </router-link>

          <!-- <div class="lastUpdated ml-2">
                        Last Updated: {{ lastUpdated }}
                    </div> -->
        </div>
      </div>
    </div>
    <div class="card p-2 revampCard" v-if="priceTrackingtableDataShow && storePriceTableData.tiles">
      <!-- tiles -->
      <div   
                class="tw-flex tw-justify-between tw-items-center tw-mb-6 tw-border-b-[1px] tw-border-[#D4D4D4]">
        <!-- <div class="tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2">Compliance Score </div> -->
        <div class="d-flex overflow-auto sovReviewedTab ">
          <div
            @click="handleTabPanel('compliance_score')"
            class="mx-3 font-bold tab-label"
            style="cursor: pointer"
            :class="{ active: 'compliance_score' === activeTab }"
          >
            Compliance Score
          </div>
          <div
            @click="handleTabPanel('competitor')"
            class="mx-3 font-bold tab-label"
            style="cursor: pointer"
            :class="{ active: 'competitor' === activeTab }"
          >
            Competitor Data
          </div>
        </div>
        <div class="tw-flex tw-gap-4" v-if="activeTab=='compliance_score'">
          <div >
              <i
                  class="fa fa-circle"
                  style="color:#DB1010"
                ></i> <=80%
          </div>
          <div> <i
                  class="fa fa-circle"
                  style="color:#FCB117"
                ></i>
                <=90% </div>
          <div> <i
                  class="fa fa-circle"
                  style="color: #065559"
                ></i>
                >90%</div>
        </div>
      </div>
      <div class="tw-grid tw-grid-cols-4 tw-gap-4 2xl:tw-grid-cols-5" v-if="activeTab=='compliance_score'"> 
          <div v-for="(tile, index) of storePriceTableData.tiles" :key="index" class="tw-p-3 tw-border-[1px] tw-border-[#D4D4D4] tw-rounded-[5px]">
            <div class="tw-font-[600] tw-text-[14px] tw-leading-[20px] tw-text-[#050A13] tw-mb-3">
              <img :src="tile[0].img" class="tw-inline-block tw-mr-2 tw-w-[22px]" />
              {{ index }}
            </div>
            <div class="tw-border-b-[1px] tw-border-[#D4d4d4]"></div>
            <div v-for="(value, key) of tile" :key="key" class="tw-flex tw-px-3 tw-mt-3 tw-py-4 tw-justify-between  tw-items-center tw-p-3 tw-border-[1px] tw-border-[#D4D4D4] tw-rounded-[2.5px]">
              <div class="tw-flex-col">
                <div class="tw-text-[#5E5E5E] tw-text-[12px] tw-leading-4 tw-font-[400]">Label</div>
                <div class="tw-leading-[20px] tw-mt-2 tw-text-[14px] tw-text-[#000] ">
                  {{ value.label }}
                </div>
              </div>
              <div class="tw-flex-col">
                <div class="tw-text-[#5E5E5E] tw-text-[12px] tw-leading-4 tw-font-[400]">Count</div>
                <div class="tw-leading-[20px] tw-mt-2 tw-text-[14px] tw-text-[#000] ">
                  {{ value.unbreach_count }}<span class="tw-text-[#505050]">/{{ value.unique_family }}</span>
                </div>
              </div>
              <div>
                  <div
                    class="tw-flex tw-items-center tw-border-[1px] tw-border-[#d4d4d4] tw-rounded-full tw-p-[6px]"
                    :class="value.percentage <= 80 
                      ? 'tw-text-[#DB1010]' 
                      : value.percentage <= 90 
                        ? 'tw-text-[#FCB117]' 
                        : 'tw-text-[#065559]'"
                  >
                    <div class="tw-relative tw-w-[16px] tw-h-[16px] tw-mr-2">
                    <svg class="tw-w-full tw-h-full tw-rotate-[-90deg]" viewBox="0 0 36 36">
                      <!-- Gray Track -->
                      <circle
                        class="tw-stroke-[#D4D4D4] tw-fill-none"
                        stroke-width="2"
                        cx="18"
                        cy="18"
                        r="15.9155"
                      />
                      <!-- Progress Circle -->
                      <circle
                        class="tw-fill-none tw-transition-all tw-duration-500"
                        :class="value.percentage <= 80
                          ? 'tw-stroke-[#DB1010]'
                          : value.percentage <= 90
                            ? 'tw-stroke-[#FCB117]'
                            : 'tw-stroke-[#065559]'"
                        stroke-width="3"
                        stroke-dasharray="100, 100"
                        :stroke-dashoffset="100 - value.percentage"
                        stroke-linecap="round"
                        cx="18"
                        cy="18"
                        r="15.9155"
                      />
                    </svg>
                    </div>
                    <div class="tw-text-[12px] tw-leading-[16px]">{{ value.percentage }}%</div>
                  </div>
                </div>

            </div>
          </div>
      </div>
      <div class="" v-if="activeTab=='competitor'"> 
         <div class="" v-if="viewComptTableData.data.length" >
            <table id="comp_table_data" 
            v-if="Object.keys(viewComptTableData).length"
            class="table" 
            style="width: 100%; overflow: hidden">
              <thead class="thead-normal">
                <tr >
                  <template v-for="head in viewComptTableData.headers" >
                    <th v-if="head.subData==1" rowspan="2">{{head.label}}</th>
                    <th
                      v-else
                      :colspan="head.subData">
                      <div class="tw-flex tw-justify-center">
                        <img v-if="head.img" :src="head.img" style="width: 19px; max-height: 19px; margin-right: 4px"/>
                        {{ head.label }}
                      </div>
                    </th>
                  </template>
                </tr>
                <tr>
                  <template
                    v-for="header in viewComptTableData.headers" 
                    v-if="header.subData!==1"
                  >
                    <th
                      v-for="subhead in header.child"
                      :key="subhead.key"
                    >
                      <div
                        class="tw-flex tw-items-center tw-gap-2 tw-justify-center"
                      >
                        {{subhead.value}}
                      </div>
                    </th>
                  </template>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, rowIndex) in viewComptTableData.data"
                  :key="row.pincode + '|' + rowIndex"
                  class="tw-border tw-border-[#d4d4d4] tw-capitalize"
                >
                  <template
                    v-for="header in viewComptTableData.headers"
                  >
                    <td v-if="header.key=='product_image'" :key="header.key + '-' + rowIndex" >
                        <img :src="row[header.key]" class="tw-inline-block tw-mr-2 tw-w-[22px]"/>
                    </td>
                    <td v-else-if="header.subData==1" >{{row[header.key] }}</td>
                    <td
                      v-else
                      v-for="subData in header.child"
                      :key="header.key + '-' + subData.key"
                    >
                      <div v-if="subData.key=='main_price'" class="tw-p-0 tw-cursor-pointer" :style="getBackgroundColor(row[header.key]?.price_diff)" @click="handleHTMLClick(row.main_variant_name, row.pincode, header.key, row[header.key].main_item_id)">
                          {{row[header.key][subData.key]}}
                      </div>
                      <div class="tw-cursor-pointer" v-else-if="subData.key==='competitor_price'" @click="handleHTMLClick(row.main_variant_name, row.pincode, header.key,row[header.key].competitor_item_id)">{{row[header.key][subData.key]}}</div>
                      <div v-else>
                        {{row[header.key][subData.key]}}
                      </div>
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
           
          </div>
          <div v-else>
            <noData :loaderVariable="tableloader" />
          </div>
      </div>
    </div>
    <div class="card p-2 revampCard" v-show="activeTab=='compliance_score'">
          <!-- price table -->
          <!-- <div class=" tw-pb-2 tw-mb-2 tw-border-b-[1px] tw-border-[#D4D4D4] tw-text-[16px] tw-text-[#065559] tw-font-[600]">Summary</div> -->
          <div class="tw-flex tw-justify-between tw-items-center tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4]">
            <div class="tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2">Summary</div>
            <div>
                <div>
                    <div style="margin-top: 0">
                        <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                            <b-form-radio-group class="radiohide" id="radiosBtn" buttons
                                button-variant="outline-secondary" v-model="selectedPriceFilter"
                                name="radiosBtn">
                                <b-form-radio class="mx-0" style="padding: 0 8px !important"
                                    value="equal">{{
                                        translatedLang["Equal"][selectedLanguage.key] }}</b-form-radio>
                                <b-form-radio class="mx-0" style="padding: 0 8px !important"
                                    value="low">{{
                                        translatedLang["Low"][selectedLanguage.key] }}</b-form-radio>
                                <b-form-radio class="mx-0" style="padding: 0 8px !important"
                                    value="high">{{
                                        translatedLang["High"][selectedLanguage.key] }}</b-form-radio>
                                <b-form-radio class="mx-0" style="padding: 0 8px !important"
                                    value="all">{{
                                        translatedLang["All"][selectedLanguage.key] }}</b-form-radio>
                            </b-form-radio-group>
                        </b-button-toolbar>
                    </div>
                </div>
                <!-- <div class="tw-flex tw-gap-4" v-if="storePriceTableData?.disclaimer">
                    <div v-for="(data,idx) of storePriceTableData.disclaimer" :key="data">
                      <span class="tw-font-bold tw-text-[#DB1010]" v-if="idx=='OOS'" >{{idx}} : </span> <span class="tw-font-bold" v-else >{{idx}} : </span>  <span >{{ data }}</span>
                    </div>
                </div> -->
            </div>
          </div>
          <div class="mt-3" v-if="priceTrackingtableDataShow">
            <table
              class="table"
              v-if="storePriceTableData.header.length"
              id="price-tracking-table"
              style="width: 100%; overflow: hidden"
            >
              <thead class="thead-normal">
                <tr>
                  <th
                    style="padding: 10px 0 !important"
                    scope="col"
                    v-for="th in storePriceTableData.header"
                    :key="th.key"
                    class="p-2"
                  >
                    <div
                      v-if="th.img"
                      class="tw-flex tw-justify-center tw-items-center tw-gap-1"
                    >
                      <img :src="th.img" style="width: 19px; max-height: 19px" />
                      {{ th.label }}
                    </div>
                    <div v-else>{{ th.label }}</div>
                  </th>

                  <th>{{ translatedLang["TrendLine"][selectedLanguage.key] }}</th>
                </tr>
              </thead>
              <tbody class="tbody-normal">
                <tr v-for="(row, i) in storePriceTableData.data" :key="i">
                  <td
                    v-for="(d, j) in storePriceTableData.header"
                    :key="j"
                    :style="[
                      d.key == 'product_name'
                        ? { 'min-width': '100px','width':'100px' }
                        : d.key == 'variant_name'
                        ? { 'min-width': '100px','width':'100px' }
                        : d.key == 'pincode'
                        ? { width: '6%', 'min-width': '70px' }
                        : d.key == 'flipkart_grocery'
                        ? { width: '11%', 'min-width': '100px' }
                        : { width: '9%', 'min-width': '100px' },
                    ]"
                  >
                    <a
                      :href="row.product_image"
                      target="_blanck"
                      v-if="d.key == 'product_image'"
                      style="display: flex; justify-content: center"
                    >
                      <div
                        class="rounded imageContainerPriceTracking tw-cursor-pointer"
                        style="
                          width: 50px;
                          text-transform: capitalize;
                          background: linear-gradient(
                            180deg,
                            rgba(0, 0, 0, 0.05) 0%,
                            rgba(255, 255, 255, 0) 100%
                          );
                          border-bottom: 1px solid #ebebeb;
                        "

                      >
                        <img
                          v-if="row[d.key]"
                          :src="row[d.key]"
                          style="
                            width: 100%;
                            mix-blend-mode: multiply;
                            padding: 10px;
                          "
                        />
                        <!-- <img v-else
                                                src="https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"
                                                style="width: 100%"></img> -->
                        <img
                          v-else
                          src="../../../public/Icons_SVG/noProductImage.svg"
                          style="width: 100%"
                        />
                      </div>
                    </a>

                    <div v-if="d.key == 'product_name'">
                      <span class="text-capitalize">{{ row[d.key] }}</span>
                    </div>
                    <div v-if="d.key == 'variant_name'">
                      <span class="text-capitalize">{{ row[d.key] }}</span>
                    </div>
                    <div v-if="d.key == 'pincode'">
                      <span class="text-capitalize">{{ row[d.key] }}</span>
                    </div>
                    <div v-if="d.key == 'mrp'">
                      <span
                        class="text-capitalize"
                        :class="[row[d.key] == 'OOS' && 'outOfStockColor']"
                        >{{ row[d.key] }}</span
                      >
                    </div>
                    <div v-if="d.key == 'sku'">
                      <span
                        class="text-capitalize"
                        >{{ row[d.key] }}</span
                      >
                    </div>
                    <!-- <div v-else>
                                        {{ row[d.key] }}
                                    </div> -->
                    <div class="d-flex justify-content-center align-items-center tw-cursor-pointer" @click="handleHTMLClick(row?.variant_name,row?.pincode,d.key,row.platform[d.key]?.item_id)">
                      <div v-if="row.platform[d.key]" class="">
                        <div
                          :class="[
                            row.platform[d.key].price === 'OOS' &&
                              'outOfStockColor',
                          ]"
                        >
                          {{ row.platform[d.key].price }}
                        </div>
                        <div
                          class="tw-text-[12px] tw-flex tw-gap-1 tw-items-center"
                          v-if="
                            checkPriceDiff(row.platform[d.key].price_diff) == 'up'
                          "
                        >
                          <img
                            style="width: 8px; height: 8px; color: green"
                            class="mb-1 mr-1"
                            src="../../../public/Icons_SVG/upPriceArrow.svg"
                          />
                          {{ row.platform[d.key].percentage_change.toFixed(2) }}%
                        </div>
                        <div
                          class="outOfStockColor tw-text-[12px] tw-flex tw-gap-1 tw-items-center"
                          v-if="
                            checkPriceDiff(row.platform[d.key].price_diff) == 'down'
                          "
                        >
                          <img
                            style="width: 8px; height: 8px"
                            class="mb-1 mr-1"
                            src="../../../public/Icons_SVG/downPriceArrow.svg"
                          />
                          {{
                            Math.abs(
                              row.platform[d.key].percentage_change.toFixed(2)
                            )
                          }}%
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style="width: 2%">
                    <div
                      @click="
                        processTrendLineModal(
                          row.segment,
                          row.product_name,
                          row.sku,
                          row.pincode
                        )
                      "
                      class="icon showTrandLine"
                    >
                      <i class="fa fa-line-chart"></i>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            v-else-if="!priceTrackingtableDataShow && tableloader"
            class="onLoadingData mt-0"
          >
            {{ translatedLang["Loading"][selectedLanguage.key] }}...
          </div>
          <div
            v-else
            class="text-danger d-flex justify-content-center border border-danger rounded p-2 noData"
          >
            {{ translatedLang["No Data Available"][selectedLanguage.key] }}.
          </div>
    </div>
  
    <!-- view html preview -->
    <b-modal
      size="xl"
      class="customModal"
      id="HTMLrenderModal"
      hide-footer
      style="z-index: 3000 !important; text-transform: capitalize"
      v-model="showHTMLModal"
    >
      <template #modal-title>
          <div>
              <h5 class="tw-text-[#00555A] tw-text-[16px] tw-mb-0">{{selectProductForHTML}}</h5>
          </div>
      </template>
      <div class="tw-flex-box tw-w-[100%] !tw-pt-0" id="htmlContentContainer">
        <div v-if="Object.keys(htmlContent).length" >
          <div class="tw-flex  tw-mb-2">
            <div class="tw-w-[130px] mr-2 tw-px-2 tw-py-1 tw-mb-1 tw-flex-end tw-text-sm tw-border-[1px] tw-border-[#d4d4d4] tw-rounded">Pincode: {{ selectedPincodeForHTML }}</div>
            <div v-if="htmlContnetTime" class="tw-w-[310px] tw-px-2 tw-py-1 tw-mb-1 tw-flex-end tw-text-sm tw-border-[1px] tw-border-[#d4d4d4] tw-rounded">Last Updated: {{htmlContnetTime}}</div>
          </div>
          <div  v-html="htmlContent" v-if="selectedPlatformforHTML!='swiggy'"></div>
          <iframe v-else class="html-frame" :srcdoc="htmlContent"></iframe>
        </div>

        <div v-else>
          <noData :loaderVariable="htmlModalLoader" />
        </div>
      </div> 
    </b-modal>
    <!-- trendLine graph -->
    <b-modal
      size="xl"
      class="customModal"
      id="trendLineModal"
      hide-footer
      style="z-index: 3000 !important; text-transform: capitalize"
      v-model="showTrendLineModal"
      :title="selectedProductTrendlineModal"
    >
      <!-- <div class="alert alert-danger p-3"  role="alert">
        No Data!!
      </div> -->
      <div
        class="p-2 w-100"
        id="#modalContainer"
        v-if="procedModalTrandLineData.xAxis"
      >
        <div style="display: flex; width: 100%" class="flex-wrap">
          <div class="mr-2 ml-0">
            <div
              class="mb-1 ml-1"
              style="
                font-size: 14px;
                font-weight: 400;
                font-family: 'Poppins';
                color: #1e1e1e;
              "
            >
              {{ translatedLang["Date Range"][selectedLanguage.key] }}
            </div>
            <date-range-picker
              v-model="trendlineModalDateRange"
              opens="right"
              :autoApply="true"
              :locale-data="{ format: 'dd mmm yyyy' }"
              :min-date="minDate"
              :max-date="maxDate"
            >
            </date-range-picker>
          </div>
          <div class="custom_dropdown customMultiselect" style="width: 15rem">
            <div
              class="mb-1 ml-1"
              style="
                font-size: 14px;
                font-weight: 400;
                color: #1e1e1e;
                font-family: 'Poppins';
              "
            >
              {{ translatedLang["Platforms"][selectedLanguage.key] }}
            </div>
           <multiselect
              v-model="selectedPlatformTrendlineModal"
              class="text-capitalize"
              :options="platformList.filter((data)=>data.key!=='All')"
              track-by="key"
              label="value"
              :custom-label="updateSelectedLabels"
              :multiple="true"
              :searchable="false"
              placeholder="Select Platform"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedPlatformTrendlineModal?.length == platformList?.length ? 1 : 100
              "
            >
              <template #option="{ option }">
                <div class="tw-flex tw-gap-2">
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedPlatformTrendlineModal"
                  />
                  <div class="custom-option text-capitalize">
                    {{ option.value }}
                  </div>
                </div>
              </template>
            </multiselect>
          </div>         
          <div
            class="ml-2 customMultiselect"
            style="width: 9rem"
            v-if="viewPinListModalTrendLine && getKeyForPriceTrackingPincode"
          >
            <div
              class="mb-1 ml-1"
              style="font-size: 14px; font-weight: 400; color: #1e1e1e"
            >
              {{ translatedLang["Pincode"][selectedLanguage.key] }}
            </div>
            <treeselect
              v-model="selectedPinTrendLineModal"
              :options="viewPinListModalTrendLine"
              :disabled="false"
              value-consists-of="LEAF_PRIORITY"
              :disable-branch-nodes="true"
              placeholder="Select PIN(s)"
              :multiple="false"
              :searchable="true"
            >
              <span slot="noResult">{{
                translatedLang["No elements found"][selectedLanguage.key]
              }}</span>
            </treeselect>
          </div>

          <div class="d-flex align-items-end mb-md-1">
            <button
              :disabled="trendLineGraphLoader"
              @click="filterApplyForTrendLine"
              class="btn primarycolor d-flex justify-content-center align-items-center ml-3"
            >
              <b-spinner
                small
                class="mr-2"
                v-if="trendLineGraphLoader"
              ></b-spinner>
              <span
                >{{ translatedLang["Apply Filters"][selectedLanguage.key] }}
              </span>
            </button>
          </div>
        </div>
        <div>
          <div v-if="onPriceTabletrendLineShowData" class="mt-2">
            <lineChart :data="procedModalTrandLineData" />
            <!-- :chartId="selectedSegmentTrendlineModal"  -->
          </div>
          <div
            v-else-if="
              !onPriceTabletrendLineShowData &&
              (firstTimeTrendLineLoader || trendLineGraphLoader)
            "
            class="onLoadingData mt-2"
          >
            {{ translatedLang["Loading"][selectedLanguage.key] }}...
          </div>
          <div
            v-else
            class="text-danger d-flex justify-content-center border border-danger rounded p-2 noData mt-3"
            style="font-family: Poppins"
          >
            {{ translatedLang["No Data Available"][selectedLanguage.key] }}.
          </div>
        </div>
      </div>
    </b-modal>
  </div>
  </div>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";
// import exportingInit from "highcharts/modules/exporting";
// import stockInit from "highcharts/modules/stock";
// import offlineExporting from "highcharts/modules/offline-exporting";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import lineChart from "../commonCharts/lineChart.vue";
import Loader from "../Components/Loader.vue";
import { mapState, mapActions } from "vuex";
import GaugeChart from "../commonCharts/GaugeChart.vue";
import noData from '../Components/noData.vue';
// stockInit(Highcharts);
// exportingInit(Highcharts);
// offlineExporting(Highcharts);

export default {
  name: "PriceFunFood",
  components: {
    Datepicker,
    Multiselect,
    Treeselect,
    lineChart,
    Loader,
    noData,
  },
  data: function () {
    return {
      data: {},
      moment: moment,
      seriesDataFiltered: [],
      timestamp: moment().subtract(8, "days").format("YYYY-MM-DD"),
      timestamp2: moment().subtract(1, "days").format("YYYY-MM-DD"),
      dateRange: {
        startDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      dateSingle: {
        startDate: moment(10-11-2025).format("YYYY-MM-DD"),
        endDate: moment(10-11-2025).format("YYYY-MM-DD"),
      },
      trendlineModalDateRange: {
        startDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      backuptrendLineModalDateRange: {
        startDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      minDate: new Date(moment().subtract(1, "month")),
      timestamp2: moment().add(1, "days").format("YYYY-MM-DD"),
      timestamp1Disabled: {
        to: "",
        from: "",
      },
      timestamp2Disabled: {
        to: "",
        from: "",
      },
      catOptions: [],
      loader0: false,
      loader: false,
      // loader1: false,
      loaderPinList: false,
      trendLinePincodeLoader: false,
      trendLineGraphLoader: false,
      firstTimeTrendLineLoader: false,
      downloadExelLoader: false,
      tableloader: true,
      loader1: false,
      loader3: false,
      selectedCat: "",
      schKey: "",
      dataFull: {},
      chartData: [],
      selectedPlatform: this.getAllPlatformsOption(),
      platformColor: {
         swiggy: "#FB8019",
        zepto: "#70339c",
        flipkart_grocery: "#4B659C",
        amazon: "#D48722",
        dmart: "#61B093",
        jiomart: "#FD5542",
        bigbasket: "#666872",
        blinkit: "#F8CC44",
        amazon_retail: "#231F20",
        flipkart: "#2874f0",
        boat: "#ED1C24",
        noon: "#E1D00D",
        croma: "#8A2387",
        myntra: "#FF3F6C",          // Myntra pink
        vijaysales: "#E31E24",           // Deep retail red (distinct from Reliance)
        reliance_digital: "#0F3CC9", // Reliance Digital blue
        tatacliq: "#E42529",
        nykaa_fashion: "#FC2779",
      },
      platformForRR: {
        amazon_retail: "#83c42a",
        flipkart: "#2874f0",
        blinkit: "rgb(248, 203, 70)",
      },
      locationDropdown: {
        options: "",
        checkSelectedPins: [],
        selectedPin: "",
      },
      segmentDropdown: {
        options: [],
        optionsForTableInsideTrendLine: [],
        selectedSegment: this.getAllCategoryOption(),
      },
      isSegment: false,
      client: JSON.parse(localStorage.reviewUserData).data.client,
      featureId: JSON.parse(localStorage.reviewUserData).data.feature_id_map["Price_Tracking"],
      selectedExportButton: "20SKU",
      isDropdown: false,
      lastUpdated: `${moment().format("YYYY-MM-DD")} 11:00 AM`,
      refreshFilterState: "",
      storePriceTableData: {
        header: [
          { key: "product_image", value: "product Image" },
          { key: "product_name", value: "product Name" },
        ],
        data: [],
      },
      isSelectedSegment: true,
      showTrendLineModal: false,
      procedModalTrandLineData: { xAxis: [] },
      selectedProductTrendlineModal: "",
      selectedPlatformTrendlineModal: [],
      selectedSegmentTrendlineModal: this.getAllCategoryOption(),
      storeSKUForTrendLineModal: "",
      viewModalTrendLineData: [],
      selectedPinTrendLineModal: "",
      allPlaformSelectedBoolean: true,
      storeAllPlatformsListForForMultiSelect: [],
      viewPinListModalTrendLine: [],
      competitorCheckBoxDataValue: false,
      selectedPlatformLastUpdate: "",

      loaderStatus: false,
      storeAllDataForStatus: {},
      priceTrackingtableDataShow: false,
      storeAllPriceTrackingPlatformsList: [],
      storeAllPlatformWiseCategory: {},
      allCommonSegements: [],
      onPriceTabletrendLineShowData: false,
      getKeyForPriceTrackingPincode: JSON.parse(localStorage.reviewUserData)
        .data.pincode_avaliable,
      showNoDataImgForUser: false,
      // new variable 
      platformList:'',
      priceRangeList:[],
      previousPriceRangeSelection:'',
      previousSelection:'',
      batchList:'',
      selectedBrand:'',
      allCategory:'',
      categoryList:'',
      selectedTableCategory:'',
      finalSelectedCategory:'',
      subCategoryList:'',
      selectedTableSubCategory:'',
      previousSubCategorySelection:'',
      selectedBrand:'',
      lossSelectedBrand:'',
      lossBrandList:'',
      previousBrandSelection:'',
      lossSelectedPriceRange:'',
      lossPriceRangeList:'',
      previousPriceRangeSelection:[],
      lossSelectedProduct:'',
      lossProductList:'',
      previousProductSelection: [],
      lossSelectedPIN:'',
      lossPINList:'',
      allPincodeList:'',
      lossSelectedBatch:{},
      lossBatchList:'',
      batchList:'',
      //Label Data filter
      labelList:'',
      selectedLabel:'',
      previousLabelSelection:'',
      //fitler data
      selectedPriceFilter: "all",
      // htmlView 
      htmlModalLoader: false,
      showTemplateModal: false,
      showHTMLModal: false,
      htmlContent: {},
      htmlContnetTime: null,
      selectProductForHTML:'',
      selectedPincodeForHTML:'',
      selectedPlatformforHTML:'',
      activeTab: 'compliance_score',
      viewComptTableData:{data:[]}
    };
  },
  // created() {
  //     window.addEventListener("click", this.close)
  // },

  // created() {
  //     window.addEventListener("click", this.close)
  // },
  // beforeDestroy() {
  //     window.removeEventListener("click", this.close)
  // },
  mounted() {
    this.dataAPIs();
  },

  watch: {
    showTrendLineModal(prevVal) {
      if (!prevVal) {
        this.allPlaformSelectedBoolean = true;
        this.trendlineModalDateRange.endDate =
          this.backuptrendLineModalDateRange.endDate;
        this.trendlineModalDateRange.startDate =
          this.backuptrendLineModalDateRange.startDate;
        this.selectedPinTrendLineModal = "";
        setTimeout(() => {
          this.onPriceTabletrendLineShowData = false;
        }, 200);
      }
    },

    dateSingle: {
      handler() {
        // this.getAllStatusByApi();
      },
      deep: true,
      immediate: true,
    },

    "segmentDropdown.selectedSegment": function () {
      if (
        Object.keys(this.storeAllDataForStatus).length &&
        this.selectedPlatform.platform_id !== "" &&
        this.segmentDropdown.selectedSegment.key !== ""
      ) {
        this.$store.dispatch(
          "DemoStore/setUpdatedStatus",
          this.storeAllDataForStatus[this.selectedPlatform.platform_id][
            this.segmentDropdown.selectedSegment.key
          ]
        );
      } else {
        this.$store.dispatch("DemoStore/setUpdatedStatus", "");
      }
    },
     selectedTableCategory(newVal) {
      let mergedChildren = [];
      newVal.forEach((cat) => {
        if (cat.child && Array.isArray(cat.child)) {
          mergedChildren.push(...cat.child);
        }
      });
      this.subCategoryList = mergedChildren;
      if (this.selectedTableCategory?.length && this.subCategoryList.length) {
        this.subCategoryList.unshift({
          key: "All",
          value: "All",
        });
      }
      this.selectedTableSubCategory = this.subCategoryList;
      this.previousSubCategorySelection = [...this.selectedTableSubCategory];
    },
    selectedPriceFilter: function () {
          // this.getTrendline();
          this.filterTablePriceData();
    },
  },
  // beforeDestroy() {
  //     window.removeEventListener("click", this.close)
  // },
  computed: {
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
  },
  methods: {
    ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
    ]),
    dataAPIs() {
      this.getLastUpdatedDates();
    },
    handleTabPanel(tabName){
      this.activeTab = tabName;
      this.tableloader = true;
      if(tabName ==='competitor'){
        this.getProductIdData().then(()=>{ 
            if ($.fn.DataTable.isDataTable("#comp_table_data")) {
              $("#comp_table_data").DataTable().clear().destroy();
            }
            this.getComptTableData();
         }).catch(()=>{
          console.log('error in fetching product id data');
         });
      }
      else if(tabName ==='compliance_score'){
          this.getProductIdData().then(()=>{
            this.getTableData();
            this.getLabelData();
          }).catch(()=>{
            console.log('error in fetching price tracking table data');
          })
       }
    },
    getBackgroundColor(diff){
      if(diff < 0){
        return {backgroundColor: '#ff999a'};
      }
      else if(diff > 0){
        return {backgroundColor: '#ffcc66'};
      }
      else{
        return {backgroundColor: '#fff'};
      }
    },
    async filterTablePriceData(){
      this.tableloader = true;
      this.storePriceTableData.data = [];
      this.priceTrackingtableDataShow=false;
      if ($.fn.DataTable.isDataTable("#price-tracking-table")) {
        $("#price-tracking-table").DataTable().clear().destroy();
      }
      if(this.selectedPriceFilter==='all'){
        this.storePriceTableData.data= this.storePriceTableData.dataForFilter;
      }
      else if(this.selectedPriceFilter==='high'){
        this.storePriceTableData.data = this.storePriceTableData.dataForFilter.filter(key=>key.high_price===true);
      }
      else if(this.selectedPriceFilter==='low'){
        this.storePriceTableData.data = this.storePriceTableData.dataForFilter.filter(key=>key.low_price===true);
      }
      else if(this.selectedPriceFilter==='equal'){
          this.storePriceTableData.data = this.storePriceTableData.dataForFilter.filter(key=>key.equal_price===true);
      }
      await this.$nextTick();
      setTimeout(() => {
        this.dataTable();
        this.tableloader = false;
      }, 10);
      this.tableloader = false;
      this.priceTrackingtableDataShow=true;
    },
    handleSelectPinChange(newVal) {
      const selectedValue = [newVal]
      if(selectedValue.some((data)=>data.label==='All')){
        if(this.lossSelectedPIN.length>=1){
          this.$nextTick(() => {
            this.lossSelectedPIN =['all'];
          });
        }
      }
      else if(selectedValue.some((data)=>data.label!=='All')){
        this.$nextTick(() => {
          this.lossSelectedPIN = this.lossSelectedPIN.filter((val) => val !=='all');
        });
      }
    },

    getLastUpdatedDates() {
      this.loader = true;

      const url = `/api/v2/india_clients/last_update?client=${this.client}&feature_id=${this.featureId}`;
      this.$http.get(url).then(
        (response) => {
          // console.log(response.body.data.data.price_tracking, 'ssss')
          if (response.body.data.price_tracking) {
            localStorage.price_tracking_last_update = JSON.stringify(
              response.body.data.price_tracking
            );
            this.setDateRangeLastUpdated();
            this.showNoDataImgForUser = false;
          }

          if (response.body.data.price_tracking == false) {
            this.showNoDataImgForUser = true;
          }
          this.loader = false;
          // this.refresh()
          // console.log(this.dateRange.startDate, this.dateRange.endDate)

          // this.getSegmentListData(); // for category and platform data
          // this.getPinListData(true); // for pincode data
          this.getFiltersData(true)
          //   this.getAllStatusByApi();
        },
        (err) => {
          this.loader = false;
          // this.refresh()
        }
      );
    },

    getAllStatusByApi() {
      //   console.log('kpl')
      let self = this;
      self.loaderStatus = true;
      const url = "api/v2/sensespiderstatus";
      let payload = {
        // "client_id": "1e5b11d71bf84ee7ac584db27d458389",
        timestamp: moment(this.dateSingle.endDate).format("YYYY-MM-DD"),
        feature: "pincode",
        feature_id: self.featureId,
      };
      self.$http
        .post(url, payload)
        .then((response) => {
          self.storeAllDataForStatus = response.body.data;
          if (
            Object.keys(self.storeAllDataForStatus).length &&
            self.selectedPlatform.platform_id !== "" &&
            self.segmentDropdown.selectedSegment.key !== ""
          ) {
            self.$store.dispatch(
              "DemoStore/setUpdatedStatus",
              self.storeAllDataForStatus[self.selectedPlatform.platform_id][
                self.segmentDropdown.selectedSegment.key
              ]
            );
          } else {
            self.$store.dispatch("DemoStore/setUpdatedStatus", "");
          }
          self.loaderStatus = false;
        })
        .catch((err) => {
          console.log(err);
          self.loaderStatus = false;
        });
    },

    setDateRangeLastUpdated() {
    let priceTrackingDate;
      priceTrackingDate = JSON.parse(localStorage.price_tracking_last_update);
      if (this.selectedPlatform.platform_id) {
        this.dateRange.endDate = priceTrackingDate[
          this.selectedPlatform.platform_id
        ]
          ? moment(
              priceTrackingDate[this.selectedPlatform.platform_id].end_date
            ).format("YYYY-MM-DD")
          : moment(priceTrackingDate.end_date).format("YYYY-MM-DD");

        this.dateRange.startDate = priceTrackingDate[
          this.selectedPlatform.platform_id
        ]
          ? moment(
              priceTrackingDate[this.selectedPlatform.platform_id].end_date
            )
              .subtract(1, "week")
              .format("YYYY-MM-DD")
          : moment(priceTrackingDate.end_date)
              .subtract(1, "week")
              .format("YYYY-MM-DD");

        this.dateSingle.endDate = priceTrackingDate[
          this.selectedPlatform.platform_id
        ]
          ? moment(
              priceTrackingDate[this.selectedPlatform.platform_id].end_date
            ).format("YYYY-MM-DD")
          : moment(priceTrackingDate.end_date).format("YYYY-MM-DD");

        this.dateSingle.startDate = priceTrackingDate[
          this.selectedPlatform.platform_id
        ]
          ? moment(
              priceTrackingDate[this.selectedPlatform.platform_id].end_date
            ).format("YYYY-MM-DD")
          : moment(priceTrackingDate.end_date).format("YYYY-MM-DD");

        this.trendlineModalDateRange.endDate = priceTrackingDate[
          this.selectedPlatform.platform_id
        ]
          ? moment(
              priceTrackingDate[this.selectedPlatform.platform_id].end_date
            ).format("YYYY-MM-DD")
          : moment(priceTrackingDate.end_date).format("YYYY-MM-DD");

        this.trendlineModalDateRange.startDate = priceTrackingDate[
          this.selectedPlatform.platform_id
        ]
          ? moment(
              priceTrackingDate[this.selectedPlatform.platform_id].end_date
            )
              .subtract(1, "week")
              .format("YYYY-MM-DD")
          : moment(priceTrackingDate.end_date)
              .subtract(1, "week")
              .format("YYYY-MM-DD");

        this.backuptrendLineModalDateRange.endDate = priceTrackingDate[
          this.selectedPlatform.platform_id
        ]
          ? moment(
              priceTrackingDate[this.selectedPlatform.platform_id].end_date
            ).format("YYYY-MM-DD")
          : moment(priceTrackingDate.end_date).format("YYYY-MM-DD");

        this.backuptrendLineModalDateRange.startDate = priceTrackingDate[
          this.selectedPlatform.platform_id
        ]
          ? moment(
              priceTrackingDate[this.selectedPlatform.platform_id].end_date
            )
              .subtract(1, "week")
              .format("YYYY-MM-DD")
          : moment(priceTrackingDate.end_date)
              .subtract(1, "week")
              .format("YYYY-MM-DD");

        this.maxDate = priceTrackingDate[this.selectedPlatform.platform_id]
          ? new Date(
              priceTrackingDate[this.selectedPlatform.platform_id].end_date
            )
          : new Date(priceTrackingDate.end_date);
        this.minDate = priceTrackingDate[this.selectedPlatform.platform_id]
          ? new Date(
              priceTrackingDate[this.selectedPlatform.platform_id].start_date
            )
          : new Date(priceTrackingDate.start_date);
      } else {
        this.dateRange.endDate = moment(priceTrackingDate.end_date).format(
          "YYYY-MM-DD"
        );

        this.dateRange.startDate = moment(priceTrackingDate.end_date)
          .subtract(1, "week")
          .format("YYYY-MM-DD");

        this.dateSingle.endDate = moment(priceTrackingDate.end_date).format(
          "YYYY-MM-DD"
        );

        this.dateSingle.startDate = moment(priceTrackingDate.end_date).format(
          "YYYY-MM-DD"
        );

        this.trendlineModalDateRange.endDate = moment(
          priceTrackingDate.end_date
        ).format("YYYY-MM-DD");

        this.trendlineModalDateRange.startDate = moment(
          priceTrackingDate.end_date
        )
          .subtract(1, "week")
          .format("YYYY-MM-DD");

        this.backuptrendLineModalDateRange.endDate = moment(
          priceTrackingDate.end_date
        ).format("YYYY-MM-DD");

        this.backuptrendLineModalDateRange.startDate = moment(
          priceTrackingDate.end_date
        )
          .subtract(1, "week")
          .format("YYYY-MM-DD");

        this.maxDate = new Date(priceTrackingDate.end_date);
        this.minDate = new Date(priceTrackingDate.start_date);
      }

      // this.dateRange.endDate = moment(
      //   response.body.data.price_tracking.end_date
      // ).format("YYYY-MM-DD");
      // this.dateRange.startDate = moment(
      //   response.body.data.price_tracking.end_date
      // )
      //   .subtract(1, "week")
      //   .format("YYYY-MM-DD");
      // this.dateSingle.endDate = moment(
      //   response.body.data.price_tracking.end_date
      // ).format("YYYY-MM-DD");
      // this.dateSingle.startDate = moment(
      //   response.body.data.price_tracking.end_date
      // ).format("YYYY-MM-DD");
      // this.trendlineModalDateRange.endDate = moment(
      //   response.body.data.price_tracking.end_date
      // ).format("YYYY-MM-DD");
      // this.trendlineModalDateRange.startDate = moment(
      //   response.body.data.price_tracking.end_date
      // )
      //   .subtract(1, "week")
      //   .format("YYYY-MM-DD");
      // this.backuptrendLineModalDateRange.endDate = moment(
      //   response.body.data.price_tracking.end_date
      // ).format("YYYY-MM-DD");
      // this.backuptrendLineModalDateRange.startDate = moment(
      //   response.body.data.price_tracking.end_date
      // )
      //   .subtract(1, "week")
      //   .format("YYYY-MM-DD");
      // this.maxDate = new Date(response.body.data.price_tracking.end_date);
      // this.minDate = new Date(
      //   response.body.data.price_tracking.start_date
      // );
      // this.handlePlatformSelection();
      this.selectedPlatform.platform_id
        ? (this.lastUpdated = `${
            priceTrackingDate[this.selectedPlatform.platform_id]
              ? moment(
                  priceTrackingDate[this.selectedPlatform.platform_id].end_date
                ).format("DD MMM, YYYY")
              : moment(priceTrackingDate.end_date).format("DD MMM, YYYY")
          } 
        ${
          priceTrackingDate[this.selectedPlatform.platform_id]
            ? priceTrackingDate[this.selectedPlatform.platform_id].latest_time
              ? "at"
              : ""
            : priceTrackingDate.latest_time
            ? "at"
            : ""
        } 
        ${
          priceTrackingDate[this.selectedPlatform.platform_id]
            ? priceTrackingDate[this.selectedPlatform.platform_id].latest_time
            : priceTrackingDate.latest_time
        }`)
        : (this.lastUpdated = `${moment(priceTrackingDate.end_date).format(
            "DD MMM, YYYY"
          )} ${priceTrackingDate.latest_time ? "at" : ""} ${
            priceTrackingDate.latest_time
          }`);
      // this.$store.dispatch("DemoStore/setTimeStamp", this.lastUpdated);

      // this.lastUpdated = ''
      this.$store.dispatch("DemoStore/setTimeStamp", this.lastUpdated);
    },
   
    checkPriceDiff(value) {
      if (value > 0) {
        return "up";
      } else if (value < 0) {
        return "down";
      }
    },

    updateSelectedLabels(option) {
      return option.value.replaceAll("_", " ");
    },

    toggleCompetitorCheckBoxDataValue() {
      this.priceTrackingtableDataShow = false;
      this.competitorCheckBoxDataValue = !this.competitorCheckBoxDataValue;
      this.getTableData();
    },

    downloadStandardExel() {
      let self = this;
      // this.loader1 = true;
      self.downloadExelLoader = true;
      // this.dataFull = {};
      let payload = {
        data: this.storePriceTableData.data,
        headers : this.storePriceTableData.header,
      };

      const url = "/api/v2/indian_clients/pincode/price_tracking_report_excel";
      self.$http.post(url, payload).then(
        (response) => {
          window.location = response.body.data;
          // this.refresh();
          self.downloadExelLoader = false;
        },
        (err) => {
          self.downloadExelLoader = false;
        }
      );
    },
    downloadCompExel() {
      let self = this;
      // this.loader1 = true;
      self.downloadExelLoader = true;
      // this.dataFull = {};
      let payload = {
       ...this.viewComptTableData
      };

      const url = "/api/india_clients/batch/price_tracking/table_compitior_excel";
      self.$http.post(url, payload).then(
        (response) => {
          window.location = response.body.data;
          // this.refresh();
          self.downloadExelLoader = false;
        },
        (err) => {
          self.downloadExelLoader = false;
        }
      );
    },
    handleHTMLClick(selectedProduct,pincode, platformKey, itemId) {
      // console.log(pincode, platformKey, itemId);
      this.selectedPlatformforHTML = platformKey;
      this.selectProductForHTML = ''
      this.selectedPincodeForHTML=''
      this.selectedPincodeForHTML = pincode;
      this.selectProductForHTML = selectedProduct;
      this.showHTMLModal = true;
      this.fetchHTML(pincode, platformKey, itemId);
    },

    fetchHTML(pincode, platformKey, itemId) {
      this.htmlModalLoader = true;
      this.htmlContent = {};
      const url = "/api/v2/india_clients/render_html/price";

      const payload = {
        timestamp: moment(this.dateSingle.endDate).format("YYYY-MM-DD"),
        identifier: pincode.toString(),
        match: itemId,
        platform: platformKey,
        batch: this.lossSelectedBatch.batch,
      };

      this.$http
        .post(url, payload)
        .then((response) => {
          const html = response.body.data;
          this.htmlContnetTime= response.body.time
          // const parseHtml= html.replace(/<\/?(html|body|head|iframe)[^>]*>/gi, "").trim();
          this.htmlContent = html
          this.htmlModalLoader = false;
        })
        .catch((error) => {
          this.htmlModalLoader = false;
          console.error("Error fetching HTML:", error);
        });
    },

    handleProductClick(data) {
      this.$store.dispatch("DemoStore/setSelectedDisparityFilters", {
        ...this.$store.state.disparityProductDetails,
        selectedProduct: [{ key: data.sku, value: data.product_name }],
      });
      const productId = data.product_name;
      const url = `/price-tracking-disparity/${productId}`;
      this.$router.push(url);
    },
    handlePlatformSelection(selected) {
      const otherOptions = this.platformList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousSelection.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedPlatform = [...this.platformList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedPlatform = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedPlatform = [...this.platformList];
        } else {
          this.selectedPlatform = [...selectedWithoutAll];
        }
      }

      this.previousSelection = [...this.selectedPlatform];

      this.changeTableCategory();
    },

    changeTableCategory() {
      if (this.selectedPlatform) {
        this.selectedTableCategory = [];
        this.lossSelectedBrand = [];
        this.lossSelectedProduct = [];
        this.lossSelectedPIN = [];
        const categoryMap = new Map();
        const subCategoryMap = new Map();

        this.categoryList = [];
        this.subCategoryList = [];
        this.selectedPlatform.forEach((platform) => {
          const platformKey = platform.key;
          const categories = this.allCategory[platformKey];

          if (categories?.length) {
            categories.forEach((cat) => {
              if (!categoryMap.has(cat.key)) {
                categoryMap.set(cat.key, cat);
                this.categoryList.push(cat);
              }

              if (cat.child?.length) {
                cat.child.forEach((sub) => {
                  if (!subCategoryMap.has(sub.key)) {
                    subCategoryMap.set(sub.key, sub);
                    this.subCategoryList.push(sub);
                  }
                });
              }
            });
          }
        });
        if (this.selectedPlatform.length) {
          this.categoryList.unshift({
            key: "All",
            value: "All",
            child: [],
          });
        }
        const stateMap = new Map();

        this.selectedPlatform.forEach((platform) => {
          const platformKey = platform.key;
          const states = this.allPincodeList[platformKey] || [];

          states.forEach((state) => {
            if (!stateMap.has(state.id)) {
              stateMap.set(state.id, {
                id: state.id,
                label: state.label,
                children: [],
              });
            }

            const stateEntry = stateMap.get(state.id);
            const cityMap = new Map(
              stateEntry.children.map((city) => [city.id, city])
            );

            state.children?.forEach((city) => {
              if (!cityMap.has(city.id)) {
                cityMap.set(city.id, {
                  id: city.id,
                  label: city.label,
                  children: [],
                });
              }

              const cityEntry = cityMap.get(city.id);
              const pinMap = new Map(
                cityEntry.children.map((pin) => [pin.id, pin])
              );

              city.children?.forEach((pin) => {
                if (!pinMap.has(pin.id)) {
                  pinMap.set(pin.id, {
                    id: pin.id,
                    label: pin.label,
                  });
                }
              });

              cityEntry.children = Array.from(pinMap.values());
            });

            stateEntry.children = Array.from(cityMap.values());
          });
        });

        this.PINList = Array.from(stateMap.values());
        this.handleChangeCategory();
      }
    },

    handleChangeCategory(selected) {
      if (!selected?.length) {
        this.selectedTableSubCategory = [];
      }

      const otherOptions = this.categoryList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected?.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousCategorySelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedTableCategory = [...this.categoryList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedTableCategory = [];
      } else {
        const selectedWithoutAll = selected?.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedTableCategory = [...this.categoryList];
        } else {
          this.selectedTableCategory = [...selectedWithoutAll];
        }
      }

      this.previousCategorySelection = [...this.selectedTableCategory];

      this.getBrandData(false);
      this.handleChangeSubCategory();
    },
    handleChangeSubCategory(selected) {
      if (!selected?.length) {
        this.selectedTableSubCategory = [];
      } else {
        const otherOptions = this.subCategoryList.filter(
          (p) => p.key !== "All"
        );

        const isAllCurrentlySelected = selected?.some(
          (opt) => opt.key === "All"
        );
        const wasAllPreviouslySelected =
          this.previousSubCategorySelection?.some((opt) => opt.key === "All");

        if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
          this.selectedTableSubCategory = [...this.subCategoryList];
        } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
          this.selectedTableSubCategory = [];
        } else {
          const selectedWithoutAll = selected?.filter(
            (opt) => opt.key !== "All"
          );
          if (selectedWithoutAll.length === otherOptions.length) {
            this.selectedTableSubCategory = [...this.subCategoryList];
          } else {
            this.selectedTableSubCategory = [...selectedWithoutAll];
          }
        }
      }

      this.previousSubCategorySelection = [...this.selectedTableSubCategory];
      this.getBrandData(false);
      this.getLabelData(false);
    },
    handleLabel(selected) {
      const otherOptions = this.labelList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousLabelSelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedLabel = [...this.labelList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedLabel = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedLabel = [...this.labelList];
        } else {
          this.selectedLabel = [...selectedWithoutAll];
        }
      }

      this.previousLabelSelection = [...this.selectedLabel];
      this.$nextTick(() => {
        this.getProductIdData(false);
      });
    },
    handleBrand(selected) {
      const otherOptions = this.lossBrandList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousBrandSelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.lossSelectedBrand = [...this.lossBrandList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.lossSelectedBrand = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.lossSelectedBrand = [...this.lossBrandList];
        } else {
          this.lossSelectedBrand = [...selectedWithoutAll];
        }
      }

      this.previousBrandSelection = [...this.lossSelectedBrand];
      this.$nextTick(() => {
        this.getProductIdData(false);
      });
    },
    handleProductIdSelection(selected) {
      const otherOptions = this.lossProductList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousProductSelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.lossSelectedProduct = [...this.lossProductList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.lossSelectedProduct = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.lossSelectedProduct = [...this.lossProductList];
        } else {
          this.lossSelectedProduct = [...selectedWithoutAll];
        }
      }

      this.previousProductSelection = [...this.lossSelectedProduct];
    },
    handlePriceRange(selected) {
      const otherOptions = this.lossPriceRangeList.filter(
        (p) => p.key !== "all"
      );

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "all");
      const wasAllPreviouslySelected = this.previousPriceRangeSelection?.some(
        (opt) => opt.key === "all"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.lossSelectedPriceRange = [...this.lossPriceRangeList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.lossSelectedPriceRange = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "all");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.lossSelectedPriceRange = [...this.lossPriceRangeList];
        } else {
          this.lossSelectedPriceRange = [...selectedWithoutAll];
        }
      }

      this.previousPriceRangeSelection = [...this.lossSelectedPriceRange];
      this.getProductIdData();
    },

    getAllPlatformsList() {
      let storeAllPlatforms = [];
      this.storeAllPriceTrackingPlatformsList.forEach((platform) => {
        storeAllPlatforms.push(platform);
      });

      this.storeAllPlatformsListForForMultiSelect = storeAllPlatforms;
    },

    setLastUpdatedForTrendline() {
      let storeLastUpdated = JSON.parse(
        localStorage.price_tracking_last_update
      );
      if (this.selectedPlatformTrendlineModal.length == 1) {
        this.trendlineModalDateRange.endDate = storeLastUpdated[
          this.selectedPlatformTrendlineModal[0]
        ]
          ? moment(
              storeLastUpdated[this.selectedPlatformTrendlineModal[0]].end_date
            ).format("YYYY-MM-DD")
          : moment(storeLastUpdated.end_date).format("YYYY-MM-DD");
        this.trendlineModalDateRange.startDate = storeLastUpdated[
          this.selectedPlatformTrendlineModal[0]
        ]
          ? moment(
              storeLastUpdated[this.selectedPlatformTrendlineModal[0]].end_date
            )
              .subtract(1, "week")
              .format("YYYY-MM-DD")
          : moment(storeLastUpdated.end_date)
              .subtract(1, "week")
              .format("YYYY-MM-DD");
      } else {
        this.trendlineModalDateRange.endDate = moment(
          storeLastUpdated.end_date
        ).format("YYYY-MM-DD");
        this.trendlineModalDateRange.startDate = moment(
          storeLastUpdated.end_date
        )
          .subtract(1, "week")
          .format("YYYY-MM-DD");
      }
    },

  

    setAllPlatformsFun() {
      // console.log('changes other platform')
      
      this.selectedPlatformTrendlineModal = this.selectedPlatform.filter((data)=>data.key!=='All')
      this.getPinListForModalTrendLine(true);
      // console.log('nhi')
    },

    selectPlatformsForAllList() {
      this.allPlaformSelectedBoolean = !this.allPlaformSelectedBoolean;
      this.selectedPlatformTrendlineModal = [];
      if (this.allPlaformSelectedBoolean) {
        this.storeAllPlatformsListForForMultiSelect.forEach((items) => {
          this.selectedPlatformTrendlineModal = [
            ...this.selectedPlatformTrendlineModal,
            items,
          ];
        });
      }
      // console.log('ok for all')
      if (this.getKeyForPriceTrackingPincode) {
        this.getPinListForModalTrendLine(false);
      }

      this.setLastUpdatedForTrendline();
      this.segmentDropdown.optionsForTableInsideTrendLine =
        this.allCommonSegements;
      this.selectedSegmentTrendlineModal = this.getAllCategoryOption();
      // console.log('new')
    },

    getFiltersData(isMounted) {
      let self = this;
      self.vocProductListLoader = true;
      const url = "/api/v2/product/filter_data";
      let payload = {
        start_date: moment(this.dateSingle.startDate).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.dateSingle.endDate).format(
          "YYYY-MM-DD"
        ),
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };
      self.$http
        .post(url, payload)
        .then((response) => {
          this.platformList = response.data.data.platform;
          if (this.platformList.length) {
            this.platformList.unshift({ key: "All", value: "All" });
          }
          this.lossPriceRangeList = response.data.data.price_range;
          this.lossSelectedPriceRange = this.lossPriceRangeList;
          this.previousPriceRangeSelection = [...this.lossSelectedPriceRange];
          this.selectedPlatform = [...this.platformList];
          this.previousSelection = [...this.selectedPlatform];
          if (Object.keys(response.data.data.batch).length) {
            this.lossBatchList = response.data.data.batch["price tracking"];
            this.lossSelectedBatch = this.lossBatchList[0];
            this.batchList = response.data.data.batch["price tracking"];
          }
          this.allCategory = response.data.data.category;
          this.categoryList = [];
          this.subCategoryList = [];
          const categoryMap = new Map();
          this.categoryList.unshift({
            key: "All",
            value: "All",
            child: [],
          });

          this.platformList.forEach((platform) => {
            const platformKey = platform.key;
            const categories = this.allCategory[platformKey];

            if (categories?.length) {
              categories.forEach((cat) => {
                if (!categoryMap.has(cat.key)) {
                  categoryMap.set(cat.key, cat);
                  this.categoryList.push(cat);
                }
              });
            }
          });
          this.selectedTableCategory = this.categoryList;
          this.previousCategorySelection = [...this.selectedTableCategory];
          const stateMap = new Map();

          this.selectedPlatform.forEach((platform) => {
            const platformKey = platform.key;
            const states = response.data.data.pincode[platformKey] || [];

            states.forEach((state) => {
              if (!stateMap.has(state.id)) {
                stateMap.set(state.id, {
                  id: state.id,
                  label: state.label,
                  children: [],
                });
              }

              const stateEntry = stateMap.get(state.id);
              const cityMap = new Map(
                stateEntry.children.map((city) => [city.id, city])
              );

              state.children?.forEach((city) => {
                if (!cityMap.has(city.id)) {
                  cityMap.set(city.id, {
                    id: city.id,
                    label: city.label,
                    children: [],
                  });
                }

                const cityEntry = cityMap.get(city.id);
                const pinMap = new Map(
                  cityEntry.children.map((pin) => [pin.id, pin])
                );

                city.children?.forEach((pin) => {
                  if (!pinMap.has(pin.id)) {
                    pinMap.set(pin.id, {
                      id: pin.id,
                      label: pin.label,
                    });
                  }
                });

                cityEntry.children = Array.from(pinMap.values());
              });

              stateEntry.children = Array.from(cityMap.values());
            });
          });

          this.lossPINList = Array.from(stateMap.values());
          this.lossSelectedPIN = this.lossPINList[1]?.children[0]?.children.map(
            (data) => data.id
          );

          this.allPincodeList = response.data.data.pincode;

          this.getBrandData(isMounted).then(() => {
            this.getTableData();
          });
          this.getLabelData();
         
          self.vocProductListLoader = false;
        })
        .catch((err) => {
          console.log(err);
          self.vocProductListLoader = false;
        });
    },


    async getLabelData(isMounted) {
      const url = "/api/v2/india_clients/labels";

      if (this.selectedTableSubCategory?.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      let payload = {
        category: this.finalSelectedCategory,
      };
      try {
        const res = await this.$http.post(url, payload);
        this.labelList = res.data.data;
        if (this.labelList.length) {
          this.labelList.unshift({ key: "All", value: "All" });
        }
        this.selectedLabel = this.labelList;
        this.$nextTick(() => {
          this.previousLabelSelection = [...this.selectedLabel];
        });
        await this.getProductIdData(isMounted);
      } catch (err) {
        console.error(err);
      }
    },
    async getBrandData(isMounted) {
      const url = "/api/v2/brand/data";

      if (this.selectedTableSubCategory?.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      let payload = {
        start_date: moment(this.dateSingle.startDate).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.dateSingle.endDate).format(
          "YYYY-MM-DD"
        ),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        channel: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        category: this.finalSelectedCategory,
        pincode: this.lossSelectedPIN?.length ? this.lossSelectedPIN : [],
      };
      try {
        const res = await this.$http.post(url, payload);
        this.lossBrandList = res.data.data;
        if (this.lossBrandList.length) {
          this.lossBrandList.unshift({ key: "All", value: "All" });
        }
        this.lossSelectedBrand = this.lossBrandList;
        this.$nextTick(() => {
          this.previousBrandSelection = [...this.lossSelectedBrand];
        });
        await this.getProductIdData(isMounted);
      } catch (err) {
        console.error(err);
      }
    },

    async getProductIdData(isMounted) {
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      const url = "/api/v2/product/data";
      let payload = {
        start_date: moment(this.dateSingle.startDate).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.dateSingle.endDate).format(
          "YYYY-MM-DD"
        ),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        channel: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        price_range: this.lossSelectedPriceRange?.length
          ? this.lossSelectedPriceRange
              ?.filter((price) => price.key !== "all")
              .map((price) => price.key)
          : [],
        category: this.finalSelectedCategory,
        brand: this.selectedBrand?.length
          ? this.selectedBrand
              ?.filter((p) => p.key !== "All")
              ?.map((brand) => brand.key)
          : [],
        label: this.selectedLabel?.length
          ? this.selectedLabel
              ?.filter((label) => label.key !== "All")
              .map((label) => label.key)
          : [],
      };
      if(this.activeTab ==='competitor'){
        payload.competitor_mapped = true
      }
      try {
        const res = await this.$http.post(url, payload);
        this.lossProductList = res.data.data;
        if (this.lossProductList.length) {
          this.lossProductList.unshift({ key: "All", value: "All" });
        }

        this.lossSelectedProduct = this.lossProductList;
        this.previousProductSelection = [...this.lossSelectedProduct];
        //   this.lossSelectedProduct = [this.lossProductList[0]];
        // if (isMounted) this.getTableData();
      } catch (err) {
        console.log(err);
      }
    },
    getPinListForModalTrendLine(flag) {
      let self = this;
      this.trendLinePincodeLoader = true;
      let payload = {
        timestamp: moment(this.trendlineModalDateRange.endDate).format(
          "YYYY-MM-DD"
        ),
        client: this.client,
        platform: self.selectedPlatformTrendlineModal?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        language: this.$store.state.DemoStore.selectedLanguage.key,
      };

      const url = "/api/v2/india_client/pincode_list";
      // const url = "/api/india_client/pincode_list";
      self.$http.post(url, payload).then(
        (response) => {
          // window.location = response.body.data;
          this.viewPinListModalTrendLine = response.data.data;
          if (this.viewPinListModalTrendLine.length) {
            // this.selectedPinTrendLineModal = "";
            // this.selectedPinTrendLineModal = this.lossSelectedPIN[0];
          }
          if (flag) {
            this.getModalTrendlineGraphData(true, false);
          }

          self.trendLinePincodeLoader = false;
        },
        (err) => {
          self.trendLinePincodeLoader = false;
        }
      );
    },

    formatNumber(n) {
      if (n && !isNaN(n)) {
        return Number(n).toLocaleString();
      } else {
        return n;
      }
    },

    processProductModalTrendlineGraph() {
      this.procedModalTrandLineData = {};

      let seriesData = [];
      let xAxisData = [];
      this.viewModalTrendLineData.forEach((items) => {
        xAxisData.push(moment(items.date).format("DD MMM"));
        const processedSeries = new Set();

        items.price.forEach((data) => {
          const processedName = data.name.replace(/_/g, " ");
          if (!processedSeries.has(processedName)) {

            let series = seriesData.find((s) => s.name === processedName);

            if (!series) {
              series = {
                name: processedName,
                color: this.getColorForKey(processedName), // Assign color dynamically
                tooltip: { valuePrefix: "₹" }, // Adjust tooltip prefix
                marker: {
                  enabled: true,
                  lineWidth: 3,
                  fillColor: "#fff",
                  lineColor: this.getColorForKey(processedName),
                  radius: 4,
                  // states: {
                  //   hover: {
                  //     radiusPlus: 4.1,
                  //     lineWidthPlus: 3.1,
                  //   },
                  // },
                  symbol: "circle",
                },
                dataLabels: {
                  enabled: false,
                  allowOverlap: true,
                  style: { fontWeight: "normal" },
                  formatter: function () {
                    return "₹" + this.point.y.toLocaleString();
                  },
                },
                data: [], // Initialize empty array to store data points
              };
              seriesData.push(series); // Add the new series to seriesData array
            }
            series.data.push(data.value);
            processedSeries.add(processedName);
          }
        });
      });

      this.procedModalTrandLineData = {
        id: "modalTrendLineGraph",
        xAxis: xAxisData,
        seriesData: seriesData,
        marginTop:65,
        yAxisTitle: "Price(₹)",
      };
    },

    getColorForKey(key) {
      let updateKey = key.toLowerCase().replaceAll(" ", "_");
      return this.platformColor[updateKey] || "#333";
    },

    processTrendLineModal(segment, productName, sku, pinCode) {
      // console.log(platform, segment, productName)
      // this.firstTimeTrendLineLoader = true;
      // console.log(typeof pinCode)
      this.showTrendLineModal = true;
      this.procedModalTrandLineData = { xAxis: [] };
      this.selectedPlatformTrendlineModal = [];
      this.selectedSegmentTrendlineModal = this.selectedTableSubCategory;
      this.selectedProductTrendlineModal = productName;
      //   this.selectedSegmentTrendlineModal = segment;
      this.storeSKUForTrendLineModal = sku;
      this.selectedPinTrendLineModal = "";
      this.getPinListForModalTrendLine(true);
      // this.selectPlatformsForAllList();
      this.selectedPinTrendLineModal = String(pinCode);
      this.setAllPlatformsFun();
      this.getModalTrendlineGraphData(true, false);
    },

    getModalTrendlineGraphData(getLoaderValue1, getLoaderValue2) {
      let self = this;
      self.trendLineGraphLoader = getLoaderValue2;
      self.firstTimeTrendLineLoader = getLoaderValue1;
      self.viewModalTrendLineData = [];
      let url = "/api/v2/indian_clients/price_tracking/product";

      // console.log("sdkfjsd",this.selectedPlatformTrendlineModal)
      let payload = {
        // client: self.client,
        start_date: moment(this.trendlineModalDateRange.startDate).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.trendlineModalDateRange.endDate).format(
          "YYYY-MM-DD"
        ),
        sku: self.storeSKUForTrendLineModal,
        pincode: self.selectedPinTrendLineModal,
        platforms: self.selectedPlatformTrendlineModal.length? this.selectedPlatformTrendlineModal
              ?.filter((sku) => sku.key !== "All")
              ?.map((sku) => sku.key)
          : [],
        category: this.selectedTableSubCategory,
      };
      self.$http
        .post(url, payload)
        .then((res) => {
          // console.log(res.data)
          this.onPriceTabletrendLineShowData = res.data.data_present;
          this.viewModalTrendLineData = res.data.data;
          this.processProductModalTrendlineGraph();
          self.trendLineGraphLoader = false;
          self.firstTimeTrendLineLoader = false;
        })
        .catch((err) => {
          this.$bvToast.toast(`${err.data.summary}`, {
            title: "Weavr Sense",
            variant: "danger",
            toaster: "b-toaster-top-right",
            autoHideDelay: 3000,
          });
          self.trendLineGraphLoader = false;
          self.firstTimeTrendLineLoader = false;
        });
    },

    filterApply() {
      if(this.activeTab === 'competitor'){
        this.viewComptTableData ={data:[]}
        if ($.fn.DataTable.isDataTable("#comp_table_data")) {
            $("#comp_table_data").DataTable().clear().destroy();
        }
        this.getComptTableData();
      }else{  
        this.priceTrackingtableDataShow = false;
        this.getTableData();
      }
    },

    filterApplyForTrendLine() {
      this.getModalTrendlineGraphData(false, true);
    },
    dataTableComp() {
      let self = this;
      $("#comp_table_data").DataTable({
        language: {
          search: "",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
          searchPlaceholder: "Search...",
        },
        autoWidth: false,
        ordering: true,
        pagingType: "full_numbers",
        searching: true,
        autoWidth: false,
      });
      var legends = $(`
        <div class="tw-text-sm tw-w-[100%]" style="background-color:white; float:right; gap: 10px;">
           <div class="legend-item tw-w-full tw-text-[12px]" style="background-color:white; ">
            <span class="tw-font-bold tw-w-[25px]">NA :</span>
            <span class="tw-ml-1 tw-w-[80px]"> Not Available</span>
          </div>
          
          <div class="legend-item tw-w-full tw-text-[12px]" style="background-color:white; ">
            <span class="tw-font-bold tw-w-[20px]">NL :</span>
            <span class="tw-ml-1 tw-w-[60px]"> Not Listed</span>
          </div>
          <div class="legend-item tw-w-full tw-text-[12px]" style="background-color:white; ">
            <span class="tw-font-bold tw-w-[23px]">NF :</span>
            <span class="tw-ml-1 tw-w-[65px]"> Not Found</span>
          </div>
          <div class="legend-item tw-w-full tw-text-[12px]" style="background-color:white; ">
            <span class="tw-font-bold tw-text-[#DB1010] tw-w-[35px]">OOS : </span>
            <span class="tw-ml-1 tw-w-[75px]"> Out of Stock</span>
          </div>
        </div>
      `);
      
      $("#comp_table_data_filter").prepend(legends);
        // Style the filter container to use flexbox
      $("#comp_table_data_filter").css({
        'display': 'flex',
        'background': 'none',
        'justify-content': 'end',
      });
      let search = require("../../../public/Icons_SVG/Search.svg");
      $("#comp_table_data" + "_filter > label").append(
        `<div><img src='${search}' width='20' class="tw-mx-1"/></div>`
      );

      $("#comp_table_data").wrap(
        "<div style='overflow:auto; width:100%;position:relative;'></div>"
      );
      var btn = $(
        '<input type="button" class="btn exportBtn" value="Export" id="exportBtnComp"/>'
      );
      $("#comp_table_data_filter > label").append(btn);

      $("#exportBtnComp").click(() => {
        self.downloadCompExel();
      });

    },
    dataTable() {
      let self = this;
      $("#price-tracking-table").DataTable({
        language: {
          search: "",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
          searchPlaceholder: "Search...",
        },
        autoWidth: false,
        ordering: true,
        pagingType: "full_numbers",
        searching: true,
        autoWidth: false,
      });
      var legends = $(`
        <div class="tw-text-sm tw-w-[50%]" style="background-color:white; float:right; gap: 10px;">
          <div class="legend-item tw-w-full tw-text-[12px]" style="background-color:white; ">
            <span class="tw-font-bold">NL :</span>
            <span class="tw-ml-1"> Not Listed</span>
          </div>
          <div class="legend-item tw-w-full tw-text-[12px]" style="background-color:white; ">
            <span class="tw-font-bold">NF :</span>
            <span class="tw-ml-1"> Not Found</span>
          </div>
          <div class="legend-item tw-w-full tw-text-[12px]" style="background-color:white; ">
            <span class="tw-font-bold tw-text-[#DB1010] tw-w-[35px]">OOS : </span>
            <span class="tw-ml-1 tw-w-[75px]"> Out of Stock</span>
          </div>
        </div>
      `);
      
      $("#price-tracking-table_filter").prepend(legends);
        // Style the filter container to use flexbox
      $("#price-tracking-table_filter").css({
        'display': 'flex',
        'background': 'none',
        'justify-content': 'end',
      });
      let search = require("../../../public/Icons_SVG/Search.svg");
      $("#price-tracking-table" + "_filter > label").append(
        `<div><img src='${search}' width='20' class="tw-mx-1"/></div>`
      );

      $("#price-tracking-table").wrap(
        "<div style='overflow:auto; width:100%;position:relative;'></div>"
      );

      // var compareBtn = $('<input type="button" class="btn compareBtn" value="Compare" id="compareBtn"/>');
      // $("#price-tracking-table_filter > label").append(compareBtn);

      var btn = $(
        '<input type="button" class="btn exportBtn" value="Export" id="exportBtn"/>'
      );
      $("#price-tracking-table_filter > label").append(btn);

      $("#exportBtn").click(() => {
        self.downloadStandardExel();
      });

      // $("#compareBtn").click(() => {
      //     self.$router.push("/price-tracking-compare");
      // })
    },

    getTableData() {
      let self = this;
      self.tableloader = true;
      $("#price-tracking-table").DataTable().destroy();
      this.storePriceTableData.data = [];
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      let payload = {
        // client: self.client,
        timestamp: moment(this.dateSingle.endDate).format("YYYY-MM-DD"),
        pincodes: this.lossSelectedPIN,
        platform: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        category: this.finalSelectedCategory,
        allow_competitor: self.competitorCheckBoxDataValue,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        brand_names:this.lossSelectedBrand?.length
          ? this.lossSelectedBrand
              ?.filter((p) => p.key !== "All")
              .map((brand) => brand.key)
          : [],
        product_sku:this.lossSelectedProduct?.length
          ? this.lossSelectedProduct
              ?.filter((sku) => sku.key !== "All")
              ?.map((sku) => sku.key)
          : [],
        price_range:this.lossSelectedPriceRange?.length
          ? this.lossSelectedPriceRange
              ?.filter((price) => price.key !== "all")
              .map((price) => price.key)
          : [],
        label: this.selectedLabel?.length
          ? this.selectedLabel
              ?.filter((label) => label.key !== "All")
              .map((label) => label.key)
          : [],
        batch: this.lossSelectedBatch?.batch,

      };

      const url = "/api/v2/indian_clients/price_tracking/table";
      self.$http
        .post(url, payload)
        .then((res) => {
          // self.storeAllPriceData = res.data.data;
          this.priceTrackingtableDataShow = res.data.data_present;
          const resData = res.data.data;
          const modifiedTableData = resData.data;
          const headerData = resData.headers;
          this.storePriceTableData.header = [];
          this.storePriceTableData.data = modifiedTableData;
          this.storePriceTableData.dataForFilter = modifiedTableData;
          this.storePriceTableData.header = headerData;
          if(resData.tiles){
            this.storePriceTableData.tiles = resData.tiles;
          }
          if(resData.disclaimer){
            this.storePriceTableData.disclaimer = resData.disclaimer;
          }
          this.selectedPriceFilter = 'all';
          this.$nextTick(() => {
            this.dataTable();
          });
          self.tableloader = false;
        })
        .catch((err) => {
          self.tableloader = false;
          console.log(err);
        });

      // self.loader = false
    },
    getComptTableData(){
      let self = this;
      self.tableloader = true;
      this.viewComptTableData = {data:[]};
      $("#comp_table_data").DataTable().destroy();
      this.storePriceTableData.data = [];
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      let payload = {
        // client: self.client,
        timestamp: moment(this.dateSingle.endDate).format("YYYY-MM-DD"),
        pincodes: this.lossSelectedPIN,
        platform: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        category: this.finalSelectedCategory,
        // allow_competitor: self.competitorCheckBoxDataValue,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        brand_names:this.lossSelectedBrand?.length
          ? this.lossSelectedBrand
              ?.filter((p) => p.key !== "All")
              .map((brand) => brand.key)
          : [],
        product_sku:this.lossSelectedProduct?.length
          ? this.lossSelectedProduct
              ?.filter((sku) => sku.key !== "All")
              ?.map((sku) => sku.key)
          : [],
        price_range:this.lossSelectedPriceRange?.length
          ? this.lossSelectedPriceRange
              ?.filter((price) => price.key !== "all")
              .map((price) => price.key)
          : [],
        label: this.selectedLabel?.length
          ? this.selectedLabel
              ?.filter((label) => label.key !== "All")
              .map((label) => label.key)
          : [],
        batch: this.lossSelectedBatch?.batch,

      };

      const url = "/api/india_clients/batch/price_tracking/table_compitior";
      self.$http
        .post(url, payload)
        .then((res) => {
          // self.storeAllPriceData = res.data.data;
         this.viewComptTableData = res.data.data;
         this.tableloader = false;
         this.$nextTick(() => {
            this.dataTableComp();
          });
          self.tableloadviewComptTableDataer = false;
        })
        .catch((err) => {
          self.tableloader = false;
          console.log(err);
        });
    },
    getAllCategoryOption() {
      if (
        !this.translatedLang ||
        !this.selectedLanguage ||
        !this.translatedLang["All Categories"]
      ) {
        return {
          key: "",
          value: "All Categories",
        };
      }

      return {
        key: "",
        value:
          this.translatedLang["All Categories"][this.selectedLanguage.key] ||
          "All Categories",
      };
    },

    getAllPlatformsOption() {
      if (!this.translatedLang || !this.selectedLanguage) {
        return {
          platform_name: "All Platforms",
          platform_id: "",
        };
      }

      return {
        platform_name:
          this.translatedLang["All Platforms"][this.selectedLanguage.key] ||
          "All Platforms",
        platform_id: "",
      };
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
#price-tracking-table .table th, .table td{
  padding:.15rem  !important
}
.exportButton {
  margin-left: 6px;
  height: 35px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px;
  font-weight: 600;
  padding: 0px 25px;
  letter-spacing: 0.2px;
}

.lastUpdated {
  color: #065559;
  font-size: 12px;
  padding: 5px 10px;
  border: 1px solid var(--base_color-80);
  border-radius: 6px;
  height: 35px;
  display: flex;
  align-items: center;
}

.CustomDropdown {
  border: 1px solid rgb(172, 172, 172);
  z-index: 999999999 !important;
  margin-left: 5px;
  border-radius: 3px;
  margin-top: 2px;
  position: absolute;
  background: white;
  width: 200px;
  right: 12px;
}

.customItem {
  padding: 3px 5px 2px 8px;
  cursor: pointer;
  color: var(--primary_brand);
}

.customItem:hover {
  background: var(--primary_brand-10);
}

.chartOverflow {
  overflow-x: scroll;
}

.name {
  line-height: 28px;
  text-transform: capitalize;
  font-size: 14px;
  margin-left: 5px;
}

.value {
  font-size: 14px;
  line-height: 24px;
  margin-right: 5px;
}

.leftsticker {
  width: 65px;
  float: left;
  height: 54px;
  color: white;
  font-size: 37px;
  text-align: center;
}

.rightsticker {
  width: 100%;
  /* float: left; */
  background: white;
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
}

.card {
  margin-bottom: 8px;
}

.card-body {
  padding: 0 !important;
  display: flex;
}

.productwrap {
  padding: 26px;
  padding-top: 6px;
  margin-top: 6px;
}

.swiggy_border {
  border-right: 2px solid #f5670e;
}

.zepto_border {
  border-right: 2px solid #d5b3ff;
}

.grofers_border {
  border-right: 2px solid #f15c2c !important;
}

.tatacliq_border {
  border-right: 2px solid #a9323f !important;
}

.bigbasket_border {
  border-right: 2px solid #666872 !important;
}

.blinkit_border {
  border-right: 2px solid rgb(248, 203, 70) !important;
}

.jiomart_border {
  border-right: 2px solid #fd5542 !important;
}

.tatacliq_border {
  border-right: 2px solid #a9323f !important;
}

.amazon_border {
  border-right: 2px solid #83c42a !important;
}

.amazon_retail_border {
  border-right: 2px solid #ff9900 !important;
}

.croma_border {
  border-right: 2px solid #49a7a1 !important;
}

.paytm_border {
  border-right: 2px solid #28bbf0 !important;
}

.snapdeal_border {
  border-right: 2px solid #f34741 !important;
}

.myntra_border {
  border-right: 2px solid #ec548b !important;
}

.vijaysales_border {
  border-right: 2px solid #ee4326 !important;
}

.ril_border {
  border-right: 2px solid #bfa161 !important;
}

.outofstock {
  color: red;
  float: right;
  font-size: 12px;
  margin-right: 5px;
  text-transform: capitalize;
}

.instock {
  color: var(--green);
  float: right;
  font-size: 12px;
  margin-right: 5px;
  text-transform: capitalize;
}

.flipkart_border,
.flipkart_grocery_border {
  border-right: 2px solid #2874f0 !important;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 12px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

.customSelect {
  margin-inline: 0.5rem;
}

.customSelectExport {
  margin-inline: 0.5rem;
}

.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 7px 20px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 14px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

button.insights {
  background-color: #fab937;
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 7px 20px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 14px;
}

button.insights:hover {
  background-color: #fac04c !important;
  color: white !important;
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 16px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
}

#sovindia4page {
  font-family: "Poppins", sans-serif !important;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .btn-outline-secondary.dropdown-toggle {
  color: #ffffff !important;
  background-color: var(--primary_brand-80) !important;
  border-color: var(--primary_brand-80) !important;
  line-height: 35px !important;
  padding: 0px 20px !important;
  border-radius: 5px !important;
  font-weight: 600 !important;
}

.btn-outline-secondary {
  line-height: 35px !important;
  /* border-radius: 5px; */
  color: var(--primary_brand) !important;
  background: var(--primary_brand-10) !important;
  border: 1px solid var(--primary_brand-10) !important;
  font-family: "poppins" !important;
  padding: 0px 20px !important;
}

.btn-group {
  background: var(--primary_brand-10) !important;
  border-radius: 5px !important;
  font-family: "poppins" !important;

  /* border: 1px solid var(--primary_brand-10); */
}

.datePickerBadge {
  margin-left: 6px;
  height: 35px !important;
  border: 1px solid #c5c5c5;
  border-right: none;
  display: flex;
  align-items: center;
  margin-right: -5px;
  z-index: 3;
  background: #fff;
  color: black;
  border-radius: 5px 0px 0px 5px;
  font-family: "poppins";
}

.borderBetween {
  border-bottom: 0.13rem solid #e1e1e1 !important;
  margin: 7px 0px !important;
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.searchInput input {
  height: 35px !important;
  margin-right: -5px !important;
  font-size: 14px !important;
  border-color: var(--primary_brand-60) !important;
  font-family: "poppins";
}

.searchInput input::placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins" !important;
  font-size: 16px !important;
}

.searchInput input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input:focus {
  box-shadow: none !important;
  border-color: var(--primary_brand) !important;
  font-family: "poppins";
}

.searchIcon {
  /* height: 40px; */
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  font-family: "poppins";

  background-color: var(--primary_brand);
}

.searchIcon img {
  width: 25px;
  margin: 10px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg)
    brightness(103%) contrast(104%);
}

.inputBoxTitle {
  color: var(--primary_brand);
  font-size: 16px;
  margin-bottom: 5px;
  font-family: "poppins";
}

.productListCheckbox span {
  /* font-weight: 600; */
  font-family: "Poppins", sans-serif !important;
}

.eachProduct:hover {
  background: var(--base_color-20);
}
</style>
<style>

#disparity-filters .multiselect__strong {
  display: none !important;
}
.vue-treeselect__control {
  height: 35px !important;
  border: 1px solid rgba(75, 75, 75, 0.4) !important;
  border-radius: 5px !important;
}

.vue-treeselect__multi-value {
  height: 30px !important;
  overflow: auto !important;
}

.vue-treeselect__multi-value-item {
  background-color: rgba(6, 85, 89, 1) !important;
  color: white !important;
}

.vue-treeselect__value-remove {
  color: white !important;
}

.customMultiselect .multiselect__placeholder {
  margin-bottom: 6px !important;
  padding: 0px !important;
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tags {
  border: 1px solid var(--base_color-40) !important;
  padding-top: 6px !important;
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__select {
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
  top: 56% !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag {
  background: var(--primary_brand-80) !important;
  margin-bottom: 0px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
  color: #fff !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
  border: 1px solid var(--base_color-40) !important;
  border-top: none !important;
  font-family: "poppins";
}

.customMultiselect
  .multiselect__option--selected.multiselect__option--highlight {
  background: var(--red) !important;
  color: var(--white) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
  background: var(--base_color-20) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__element {
  color: var(--primary_brand-80) !important;
  border-bottom: 1px solid var(--base_color-20);
  font-family: "poppins";
}

/* width */
.customMultiselect ::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
  background: var(--base_color-20);
  border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}

.customMultiselect .multiselect__input:focus {
  border: none !important;
  color: #000 !important;
  box-shadow: none;
}

.revampCard {
  border-radius: 0.7rem !important;
  border: none !important;
  margin: 10px;
  margin-bottom: 1rem;
}

/* datatable */
#price-tracking-table_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
  border:1px solid #065559 !important;
}

#price-tracking-table_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}

#price-tracking-table_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg)
    brightness(103%) contrast(104%);
}

#price-tracking-table_wrapper #price-tracking-table.table.dataTable th {
  background: rgba(39, 86, 89, 0.1) !important;
  background-color: none !important;
  color: #5e5e5e !important;
  font-weight: 600 !important;
  font-family: "Poppins" !important;
  font-size: 14px !important;
}

table.dataTable thead .sorting,
table.dataTable thead .sorting_asc,
table.dataTable thead .sorting_desc {
  background-image: none !important;
}

table.dataTable thead > tr > th.sorting_asc:before,
table.dataTable thead > tr > th.sorting_asc:after {
  display: none !important;
}

#price-tracking-table_wrapper #price-tracking-table.table.dataTable td {
  font-family: "Heebo" !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #5e5e5e !important;
}

#price thead {
  background: none !important;
}

.thead-normal {
  background: none !important;
}

#price-tracking-table_info {
  position: relative;
  top: 9px;
  /* left: 54%; */
  left: 0;
  z-index: 100;
  /* float: right; */
  float: none;
  /* width: 50vw; */
  width: auto;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}

#price-tracking-table_paginate {
  position: relative;
  top: 2px;
  z-index: 100;
  float: right;
}

/* .dataTables_paginate .page-link {
    border: none !important;
    background: none !important;
    color: var(--primary_brand-80) !important;
} */

#price-tracking-table_filter .exportBtn {
  margin: 0px 10px;
  height: 35px;
  width: 100px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px !important;
  font-weight: 600;
  padding: 0px !important;
  letter-spacing: 0.2px;
}

#price-tracking-table_filter .exportBtn:hover {
  background: var(--primary_brand-80);
}

/* datatable */
#comp_table_data_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
  border:1px solid #065559 !important;
}

#comp_table_data_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}

#comp_table_data_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg)
    brightness(103%) contrast(104%);
}

#comp_table_data_wrapper #comp_table_data.table.dataTable th {
  background: rgba(39, 86, 89, 0.1) !important;
  background-color: none !important;
  color: #5e5e5e !important;
  font-weight: 600 !important;
  font-family: "Poppins" !important;
  font-size: 14px !important;
}

table.dataTable thead .sorting,
table.dataTable thead .sorting_asc,
table.dataTable thead .sorting_desc {
  background-image: none !important;
}

table.dataTable thead > tr > th.sorting_asc:before,
table.dataTable thead > tr > th.sorting_asc:after {
  display: none !important;
}

#comp_table_data_wrapper #comp_table_data.table.dataTable td {
  font-family: "Heebo" !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #5e5e5e !important;
}

#price thead {
  background: none !important;
}

.thead-normal {
  background: none !important;
}

#comp_table_data_info {
  position: relative;
  top: 9px;
  /* left: 54%; */
  left: 0;
  z-index: 100;
  /* float: right; */
  float: none;
  /* width: 50vw; */
  width: auto;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}

#comp_table_data_paginate {
  position: relative;
  top: 2px;
  z-index: 100;
  float: right;
}

/* .dataTables_paginate .page-link {
    border: none !important;
    background: none !important;
    color: var(--primary_brand-80) !important;
} */

#comp_table_data_filter .exportBtn {
  margin: 0px 10px;
  height: 35px;
  width: 100px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px !important;
  font-weight: 600;
  padding: 0px !important;
  letter-spacing: 0.2px;
}

#comp_table_data_filter .exportBtn:hover {
  background: var(--primary_brand-80);
}
.compareBtn {
  margin: 0px 0 0 10px;
  height: 35px;
  width: 100px;
  border: none;
  background: white;
  border: 1px solid var(--primary_brand);
  color: var(--primary_brand);
  border-radius: 5px !important;
  font-weight: 600;
  padding: 0px !important;
  letter-spacing: 0.2px;
}

.compareBtn:hover {
  background: var(--primary_brand);
  color: #fff;
}

.dataTables_empty {
  color: #ff00009e !important;
}

.outOfStockColor {
  color: #c00000;
  font-size: 14px;
}

.noData {
  background: #fff7f7 !important;
}

.showTrandLine {
  cursor: pointer;
}

/* modal for trendLine */

#trendLineModal .modal-header {
  text-transform: capitalize;
}

.customMultiselect .multiselect__tags {
  border: 1px solid var(--base_color-40) !important;
  padding-top: 6px !important;
  min-height: 35px !important;
  max-height: 36px !important;
  overflow-y: auto;
  font-family: "poppins";
}

#modalContainer .vue-treeselect__input-container > input:focus {
  box-shadow: none;
}

#modalContainer .vue-treeselect--single .vue-treeselect__option--selected {
  background: #44777a1a !important;
  font-weight: 600;
}

button[disabled="disabled"] {
  cursor: not-allowed !important;
}

.imageContainerPriceTracking {
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.05) 0%,
    rgba(255, 255, 255, 0) 100%
  ) !important;
}

.customSelectedLabels .custom-tag {
  background: var(--primary_brand-80) !important;
  padding: 1px 0px 1px 10px;
  border-radius: 5px;
  margin-right: 5px;
  margin-bottom: 5px;
  display: inline-block !important;
  align-items: center !important;
  color: #fff !important;
}

.customSelectedLabels .custom-tag .remove-icon:hover {
  background-color: #369a6e;
  border-radius: 5px;
}

.customSelectedLabels .remove-icon {
  cursor: pointer;
  font-size: 14px;
  margin-left: 5px;
  color: #fff;
  font-weight: bold;
}

.highcharts-tooltip text {
  text-transform: capitalize !important;
}

.competitorCheckBox input[type="checkbox"]:checked {
  background-color: var(--primary_brand) !important;
  accent-color: var(--primary_brand) !important;
}

.competitorCheckBox input[type="checkbox"] {
  cursor: pointer !important;
}

.containerOverflowClass {
  width: 99.7% !important;
  overflow-x: visible !important;
}

@media screen and (max-width: 767px) {
  #price-tracking-table_paginate {
    float: none;
    width: auto;
  }
}

@media screen and (max-width: 1280px) {
  table.dataTable td {
    font-size: 13px !important;
  }
}

@media (min-width: 1034px) {
  .customWidth-70 {
    width: 70%;
  }
}
#price-tracking-table_filter input {
  width: 150px;
}
</style>
<style>
.html-frame{
  width: 100%;
  height:  180vh;
  border: none;
  overflow: auto;
}
#htmlContentContainer .header-wrap .header[data-v-73cbb32e]{
  position:absolute;
}

#disparity-filters .multiselect__strong {
  display: none !important;
}

#templateModal .month-picker-input {
  width: 460px !important;
}
@media (min-width: 1200px) {
  #HTMLrenderModal .modal-xl {
    max-width: 1600px;
  }
}
.tab-label {
  cursor: pointer;
  padding-bottom: 13px;
  transition: all 0.3s ease;
  font-size: 16px;
  font-weight: 500;
}

.tab-label.active {
  color: rgba(6, 85, 89, 1);
  border-bottom: 1px solid rgba(6, 85, 89, 1);
  font-weight: 600 !important;
}
</style>
